module.exports = __webpack_public_path__ + "static/media/logo.dda8bfce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/logo.svg
// module id = 1613
// module chunks = 2